import comp from "./AIAnalysisScale";
export default comp;
